import DictUtil from '@/utils/dict-utils'

import { purchaseAllTypeDict } from '@/dictionary/project/common'

// 谈判采购的采购类型
export const negotiateTypeDict = new DictUtil({
  COMMON: {
    value: 1,
    label: '谈判采购(机场谈判)',
    purchaseValue: purchaseAllTypeDict.NEGOTIATION.value
  },
  V2: {
    value: 2,
    label: '谈判采购(分项谈判)',
    purchaseValue: purchaseAllTypeDict.NEGOTIATION_V2.value
  }
})

// 谈判方式字典
export const negotiateMethodDict = new DictUtil({
  COMPETITIVE_CONSULT: { label: '竞争性磋商', value: 3 },
  COMPETITIVE_NEGOTIATION: { label: '竞争性谈判', value: 4 }
})

/** ************************************************************ */
/** ************项目管理*************** */
// 项目状态
export const negotiationV2PackageStatusDict = new DictUtil({
  EDIT: {
    value: 0,
    label: '编辑中',
    type: 'primary',
    permissions: ['edit', 'delete']
  },
  PUBLISHED: {
    value: 1,
    label: '已发布',
    type: 'success',
    permissions: ['detail']
  }
})

/** ************************************************************ */
/** ************分项谈判（初始为南大一附院定制）*************** */
// 项目状态
export const negotiationV2StatusDict = new DictUtil({
  UN_PUBLISHED: {
    label: '未发布',
    value: 0,
    type: 'warning',
    permission: ['edit', 'del'],
    routerName: 'NegotiationV2Form',
    commonLabel: '未发布',
    routerCommonName: 'NegotiationForm'
  },
  PUBLISHED: {
    label: '已发布',
    value: 1,
    type: 'primary',
    permission: ['look', 'copy'],
    routerName: 'NegotiationV2Info',
    commonLabel: '已发布',
    routerCommonName: 'NegotiationInfo'
  },
  APPLY: {
    label: '报名中',
    value: 2,
    type: 'primary',
    permission: ['look', 'copy'],
    routerName: 'NegotiationV2Quote',
    commonLabel: '报名中',
    routerCommonName: 'NegotiationResponse'
  },
  NEGOTIATING: {
    label: '谈判准备中',
    value: 3,
    type: 'primary',
    permission: ['look', 'copy'],
    routerName: 'NegotiationV2Quote',
    commonLabel: '接受响应中',
    routerCommonName: 'NegotiationResponse'
  },
  RESPONSE_END: {
    label: '谈判已截止',
    value: 4,
    type: 'primary',
    permission: ['look', 'copy'],
    routerName: 'NegotiationV2Quote',
    commonLabel: '响应已截止',
    routerCommonName: 'NegotiationResponse'
  },
  CANDIDATE: {
    label: '候选人公示',
    value: 5,
    type: 'primary',
    permission: ['look', 'copy'],
    routerName: 'NegotiationV2Winner',
    commonLabel: '已公示',
    routerCommonName: 'NegotiationWinner'
  },
  WINNER: {
    label: '已完成',
    value: 6,
    type: 'success',
    permission: ['look', 'copy'],
    routerName: 'NegotiationV2WinnerDetail',
    commonLabel: '已完结',
    routerCommonName: 'NegotiationWinnerDetail'
  },
  CLOSED: {
    label: '已终止谈判',
    value: 7,
    type: 'info',
    permission: ['look', 'copy'],
    routerName: 'NegotiationV2Info',
    commonLabel: '已终止谈判',
    routerCommonName: 'NegotiationInfo'
  },
  RESTART: {
    label: '已重新谈判',
    value: 8,
    type: 'info',
    permission: ['look', 'copy'],
    routerName: 'NegotiationV2Info',
    commonLabel: '已重新谈判',
    routerCommonName: 'NegotiationInfo'
  }
})

// 项目状态(有审判)
export const negotiationV2FlowStatusDict = new DictUtil({
  ...negotiationV2StatusDict.object,
  PUBLISHING: {
    value: 10,
    type: 'info',
    label: '发布中',
    commonLabel: '发布中',
    permission: ['look', 'copy'],
    routerName: 'NegotiationV2Info',
    routerCommonName: 'NegotiationInfo'
  },
  PUBLISH_ING: {
    value: 11,
    label: '发布审批中',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationInfo'
  },
  PUBLISH_PASS: {
    value: 12,
    label: '发布审批通过',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationResponse'
  },
  PUBLISH_REJECT: {
    value: 13,
    label: '发布审批不通过',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationInfo'
  },
  CHANGE_TO_DO: {
    value: 20,
    label: '待提交变更审批',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationChangeNewestDetail'
  },
  CHANGE_ING: {
    value: 21,
    label: '变更审批中',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationChangeNewestDetail'
  },
  CHANGE_PASS: {
    value: 22,
    label: '变更审批通过',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationResponse'
  },
  CHANGE_REJECT: {
    value: 23,
    label: '变更审批不通过',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationChangeNewestDetail'
  },
  CANDIDATE_TO_DO: {
    value: 30,
    label: '待提交候选公示审批',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationCandidateNewest'
  },
  CANDIDATE_ING: {
    value: 31,
    label: '候选公示审批中',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationCandidateNewest'
  },
  CANDIDATE_PASS: {
    value: 32,
    label: '确定候选审批通过',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationCandidateDetail'
  },
  CANDIDATE_REJECT: {
    value: 33,
    label: '确定候选审批不通过',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationCandidateNewest'
  },
  WINNER_TO_DO: {
    value: 40,
    label: '待提交成交审批',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationWinnerNewest'
  },
  WINNER_ING: {
    value: 41,
    label: '确定成交审批中',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationWinnerNewest'
  },
  WINNER_PASS: {
    value: 42,
    label: '确定成交审批通过',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationWinnerDetail'
  },
  WINNER_REJECT: {
    value: 43,
    label: '确定成交审批不通过',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationWinnerNewest'
  },
  AUCTION_TO_DO: {
    value: 50,
    label: '待提交流标审批',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationAuctionNeweat'
  },
  AUCTION_ING: {
    value: 51,
    label: '流标审批中',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationAuctionNeweat'
  },
  AUCTION_PASS: {
    value: 52,
    label: '流标审批通过',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationAuctionNeweat'
  },
  AUCTION_REJECT: {
    value: 53,
    label: '流标审批不通过',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationAuctionNeweat'
  },
  CLARIFICATION_TO_DO: {
    value: 60,
    label: '待提交澄清审批',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationClarificationNewestDetail'
  },
  CLARIFICATION_ING: {
    value: 61,
    label: '澄清审批中',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationClarificationNewestDetail'
  },
  CLARIFICATION_PASS: {
    value: 62,
    label: '澄清审批通过',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationResponse'
  },
  CLARIFICATION_REJECT: {
    value: 63,
    label: '澄清审批不通过',
    permission: ['look', 'copy'],
    routerCommonName: 'NegotiationClarificationNewestDetail'
  }
})

export const todoNodeDict = new DictUtil({
  APPLY: { label: '供应商报名', value: 1 },
  CANDIDATE: { label: '确定候选', value: 2 },
  WINNER: { label: '成交', value: 3 }
})

// 竞争方式
export const canCandidateDict = new DictUtil({
  YES: { label: '是', value: 0 },
  NO: { label: '否', value: 1 }
})

// 竞争方式
export const negotiationV2TypeDict = new DictUtil({
  OPEN: { label: '公开竞争', value: 1 },
  INVITE: { label: '有限竞争', value: 2 }
})

// 采购类型
export const negotiationV2ProcureTypeDict = new DictUtil({
  SINGLE_PURCHASE: { value: 1, label: '单次采购' },
  AGREED_SUPPLY: { value: 0, label: '协议供货' }
})

// 报价是否含税
export const negotiationV2RequireTaxDict = new DictUtil({
  YES: { value: 1, label: '是' },
  NO: { value: 0, label: '否' }
})

// 允许对部分品目报价
export const negotiationV2AllowPartDict = new DictUtil({
  YES: { value: 1, label: '是' },
  NO: { value: 0, label: '否' }
})

// 比价方式
export const negotiationV2CompareWayDict = new DictUtil({
  SEALING_COMPARISON: {
    value: 1,
    label: '密封比价',
    tips: '密封比价在报价截止之后才能查看供应商的报价信息'
  },
  NON_SEALING_COMPARISON: {
    value: 0,
    label: '非密封比价',
    tips: '非密封比价在供应商报价后，可随时查看报价信息及比价'
  }
})

// 是否已经发布
export const isReleaseDict = new DictUtil({
  YES: { label: '已发布', value: 2 },
  NO: { label: '编辑中', value: 1 }
})

// 是否对外发布公告
export const isPublicPublishDict = new DictUtil({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 0 }
})

// 结果公告状态
export const winnerStatusDict = new DictUtil({
  CLOSED: { label: '已关闭', value: -1 },
  EDIT: { label: '编辑', value: 1 },
  PUBLISHED: { label: '已发布', value: 2 }
})

// 公示状态
export const candidateStatusDict = new DictUtil({
  CLOSED: { label: '已关闭', value: -1 },
  EDIT: { label: '编辑', value: 1 },
  PUBLISHED: { label: '已发布', value: 2 }
})

// 流标状态
export const negotiationV2AuctionStatusDict = new DictUtil({
  RESTART: { label: '重新谈判', value: 2 },
  STOP: { label: '终止谈判', value: 1 }
})

// 中标通知书发布方式
export const winnerInformTypeDict = new DictUtil({
  OFFLINE: { label: '线下领取', value: 1 }
})

// 批量公示是否已授标
export const isAwardDict = new DictUtil({
  YES: { label: '已授标', value: 1, type: 'primary' },
  NO: { label: '未授标', value: 0, type: 'warning' }
})

// 文件预览下载类型
export const fileTypeDict = new DictUtil({
  NEGOTIATE: { label: '谈判文件', value: 1 },
  CLARIFIED: { label: '澄清文件', value: 2 }
})

// 供应商报名页面节点
export const tradeNodeDict = new DictUtil({
  APPLY: { label: '报名', value: 1 },
  APPLY_FEE: { label: '支付平台使用费', value: 2 },
  GUARANTEE: { label: '保证金缴纳', value: 3 },
  QUOTA: { label: '提交报价单', value: 4 },
  WINNER: { label: '完结', value: 7 }
})

export const negotiationV2ResultDict = new DictUtil({
  WIN: {
    label: '恭喜你！中标了！',
    value: 1,
    type: 'success'
  },
  LOSE: {
    label: '很遗憾！你未中标！',
    value: 0,
    type: 'danger'
  }
})

export const onceOfferStatusDict = new DictUtil({
  NOT_STARTED: { label: '未开始', value: 0 },
  UN_UPLOAD: { label: '未提交', value: 1 },
  UPLOAD: { label: '已提交', value: 2 },
  CAN_EDIT: { label: '可修改报价', value: 3 }
})

// 是否必须上传报价附件
export const negotiationV2OfferFileDict = new DictUtil({
  YES: { value: 1, label: '是' },
  NO: { value: 0, label: '否' }
})

/** ******************机场谈判采购************************ */
// 是否议价
export const isBargainDict = new DictUtil({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 0 }
})

// 评审状态
export const reviewNegotiationStatusDict = new DictUtil({
  INIT: { label: '未开始', value: 0 },
  DOING: { label: '进行中', value: 1 },
  FINISH: { label: '评审完成', value: 2 }
})

// 响应状态
export const responseNegotiationStatusDict = new DictUtil({
  UN_UPLOAD: { label: '未提交', value: 0, type: 'primary' },
  UPLOAD: { label: '已提交', value: 1, type: 'success' },
  WITHDRAW: { label: '已撤回', value: 2, type: 'danger' },
  STOP: { label: '已退出', value: 3, type: 'danger' }
})

// 响应文件审查状态
export const responseNegotiationAuditStatusDict = new DictUtil({
  TO_AUDIT: { label: '未审查', value: 1, type: 'primary' },
  PASS: { label: '通过', value: 2, type: 'success' },
  REJECT: { label: '不通过', value: 3, type: 'danger' }
})

// 是否免收标书费
export const negotiationBookFeeStatusDict = new DictUtil({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 2 }
})
